import { MapTo } from '@adobe/aem-react-editable-components';
import PressRelease, { PressReleaseEditConfig } from './PressRelease';

export default MapTo('cob-corp-acquisition/components/creditonebank/press-release')(PressRelease, PressReleaseEditConfig);